// extracted by mini-css-extract-plugin
export default {"story":"styles_story__EUvdE","iframe":"styles_iframe__9-AhK"};